export enum ImageElementStyle {
    SlideImage = 'SlideImage',
    TitleImage = 'TitleImage',
}
